<template>
<div>
  <v-card class="pa-2 elevation-1 grey lighten-4">
    <v-layout row wrap justify-center>
      <v-flex class="pl-3 pt-2 text-xs-center" xs12>
        <span class="secondary--text title"><b>{{courseData.name}}</b></span>
        <!-- <span class="secondary--text title"><b>{{courseData.name.slice(0, 16)}}{{courseData.name.length > 16 ? '...' : ''}}</b></span> -->
      </v-flex>
      <v-flex class="pt-2" xs10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex class="px-2 pt-2" xs12>
        <v-layout class="subheading" row wrap justify-center>
          <v-flex class="text-xs-center" xs12>
            <span :class="courseData.published ? 'success--text' : 'error--text'">
              <b>{{courseData.published ? 'Published' : 'Unpublished'}}</b>
            </span>
          </v-flex>
          <v-flex class="pb-1" xs9>
            <v-menu max-height="300px" full-width offset-y>
              <v-btn slot="activator" color="transparent" class="my-0 elevation-0" block large>
                <span class="secondary--text"><b>{{courseData.onlineDays + ' Days Online'}}</b></span>
                <v-icon class="ml-0" right>arrow_drop_down</v-icon>
              </v-btn>
              <v-list>
                <template v-for="p in courseOptions">
                  <v-list-tile v-if="courseData.key == p.key" :key="p.key">
                    <v-list-tile-title class="grey--text text--lighten-1 text-xs-center">
                      <b>{{p.onlineDays + ' Days Online'}}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-else :key="p.key" @click.native="courseData = p">
                    <v-list-tile-title class="text-xs-center">
                      <b>{{p.onlineDays + ' Days Online'}}</b>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex class="pt-2 px-2" xs12>
            <span><b>Content: </b></span>
            <span v-if="contentNames.length == 0">None</span>
            <template v-else>
              <v-chip class="my-0" v-for="c, i in contentNames" :key="i" disabled small>
                {{c}}
              </v-chip>
            </template>
          </v-flex>
          <v-flex class="pt-2 px-2" xs12>
            <span><b>Dates: </b></span>
            <span v-if="courseData.type == 'Online'">ONLINE</span>
            <template v-else>
              <v-chip class="my-0" v-for="date in courseData.dates" :key="date" disabled small>
                {{date}}
              </v-chip>
            </template>
          </v-flex>
          <v-flex class="pt-2 px-2" xs12>
            <span><b>Student Count:</b> {{studentCount}}</span>
          </v-flex>
          <v-flex class="pt-2 px-2" xs12>
            <span><b>Price:</b> ${{courseData.price}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="py-2 text-xs-center" xs12>
        <v-btn :to="'/manage-courses/' + courseData.key" class="my-0" color="primary" flat><b>view</b></v-btn>
        <v-btn @click.native="copyCourse" class="my-0" color="secondary" flat><b>copy</b></v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</div>
</template>

<script>
export default {
  props: ['courses'],
  data: () => ({
    changing: false,
    courseData: {},
    choice: ''
  }),
  computed: {
    progress () {
      return this.$store.getters.progress
    },
    courseOptions () {
      this.courseData = this.courses[0]
      return this.courses
    },
    contentNames () {
      const names = []
      if (this.courseData.content) {
        for (let key of this.courseData.content) {
          names.push(this.$store.getters.contentByKey(key).name)
        }
      }
      return names
    },
    studentCount () {
      let count = 0
      const linked = this.$store.getters.linkedCourses(this.courseData.key)
      for (let c of linked) {
        if (c.students) {
          for (let s of c.students) {
            if (this.hasProgress(s.uid)) count += 1
          }
        }
      }
      return count
    }
  },
  methods: {
    getCourseData (course) {
      this.changing = true
      setTimeout(() => {
        this.courseData = course
        this.changing = false
      }, 250)
    },
    hasProgress (uid) {
      const linkedKeys = []
      for (let c of this.$store.getters.linkedCourses(this.courseData.key)) {
        linkedKeys.push(c.key)
      }
      let rightProgress = false
      let notEnded = false
      for (let p of this.progress) {
        rightProgress = p.studentId === uid && linkedKeys.includes(p.courseKey)
        notEnded = p.endTime === 0 || this.now < p.endTime
        if (rightProgress && notEnded) return true
      }
      return false
    },
    copyCourse () {
      this.$store.dispatch('setCourseToCopy', this.courseData)
      this.$router.push('/manage-courses/create')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/CourseView.vue